import { FC, useEffect, useMemo, useState } from 'react';

import { DeliveryManageCard } from '@service/seller/components/DeliveryManageCard';
import { ShopOrderForSeller } from '@shared/api/shopOrder/shopOrder.interface';
import { useShopOrderCsMemosByOrders } from '@shared/api/shopOrderCsMemo/shopOrderCsMemo.hook';
import { DeliveryState, PaymentState } from '@shared/types';
import { Tabs, TabsProps } from 'antd';

interface Props {
  shopOrderList: ShopOrderForSeller[];
}

export const PastDeliveryManageContent: FC<Props> = function PastDeliveryManageContent({
  shopOrderList,
}: Props) {
  // CS 응대 메모 — 검색 결과 주문들을 배치 1요청으로 채운다 (각 카드는 캐시를 읽음)
  const csMemoOrderIds = useMemo(
    () => shopOrderList.map((order) => order._id),
    [shopOrderList],
  );
  useShopOrderCsMemosByOrders(csMemoOrderIds);

  const shopOrderDeliveredListDisplay = shopOrderList.filter((shopOrder) => {
    if (
      [PaymentState.PAID, PaymentState.CONFIRMED].includes(
        shopOrder.paymentDetail.status,
      ) &&
      shopOrder.deliveryDetail.status === DeliveryState.DELIVERED
    ) {
      return true;
    } else {
      return false;
    }
  });

  const shopOrderCacnceledListDisplay = shopOrderList.filter((shopOrder) => {
    if (
      [PaymentState.CANCELED, PaymentState.CANCEL_REQUESTED].includes(
        shopOrder.paymentDetail.status,
      )
    ) {
      return true;
    } else {
      return false;
    }
  });

  const [activeKey, setActiveKey] = useState('delivered');

  //* 검색 결과가 취소 건뿐이면 취소 탭을 바로 보여줌
  useEffect(() => {
    if (
      shopOrderDeliveredListDisplay.length === 0 &&
      shopOrderCacnceledListDisplay.length > 0
    ) {
      setActiveKey('canceled');
    } else {
      setActiveKey('delivered');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopOrderList]);

  const items: TabsProps['items'] = [
    {
      key: 'delivered',
      label: (
        <div className="px-4 text-gray-500">
          배송 완료 ({shopOrderDeliveredListDisplay.length})
        </div>
      ),
      children: (
        <div className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {/* Card */}
          {shopOrderDeliveredListDisplay
            .sort((a, b) => {
              const aDate = a.deliveryDetail.deliveredAt as Date;
              const bDate = b.deliveryDetail.deliveredAt as Date;
              return -aDate.getTime() + bDate.getTime();
            })
            .map((order) => (
              <DeliveryManageCard order={order} key={order._id} />
            ))}
        </div>
      ),
    },
    {
      key: 'canceled',
      label: (
        <div className="px-4 text-gray-500 ">
          취소 ({shopOrderCacnceledListDisplay.length})
        </div>
      ),
      children: (
        <div className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {/* Card */}
          {shopOrderCacnceledListDisplay.map((order) => (
            <DeliveryManageCard order={order} key={order._id} />
          ))}
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-3">
      <h2 className="text-xl font-medium leading-6 text-gray-900">과거 배송</h2>
      <Tabs activeKey={activeKey} onChange={setActiveKey} items={items}></Tabs>
    </div>
  );
};
